import { XCircle, LogOut, Mail } from 'lucide-react';
import { useAuth } from '@/hooks/useAuth';
import Button from '@/components/common/Button';

export default function RejectedPage() {
  const { cmsUser, logout } = useAuth();

  return (
    <div className="min-h-screen bg-gradient-to-br from-red-50 via-white to-surface-100 flex items-center justify-center p-4">
      <div className="w-full max-w-md text-center">

        <div className="inline-flex items-center justify-center w-20 h-20 rounded-full bg-red-100 mb-6">
          <XCircle className="h-10 w-10 text-red-600" />
        </div>

        <h1 className="text-2xl font-bold text-surface-900 mb-2">
          Access Not Approved
        </h1>

        <div className="bg-white rounded-2xl shadow-card border border-surface-200 p-6 mb-6 text-left space-y-3">
          <p className="text-surface-600 text-sm leading-relaxed">
            Unfortunately, your request for access to the WombCat CMS has not
            been approved at this time.
          </p>
          <p className="text-surface-600 text-sm leading-relaxed">
            If you believe this is a mistake, please contact your administrator
            for assistance.
          </p>
          {cmsUser?.email && (
            <div className="pt-2 border-t border-surface-100">
              <p className="text-xs text-surface-400">
                Account: <span className="font-medium text-surface-600">{cmsUser.email}</span>
              </p>
            </div>
          )}
        </div>

        <div className="flex flex-col gap-3">
          <Button
            variant="secondary"
            fullWidth
            leftIcon={<Mail className="h-4 w-4" />}
            onClick={() => window.location.href = 'mailto:admin@wombcat.com'}
          >
            Contact administrator
          </Button>
          <Button
            variant="ghost"
            fullWidth
            leftIcon={<LogOut className="h-4 w-4" />}
            onClick={logout}
          >
            Sign out
          </Button>
        </div>

      </div>
    </div>
  );
}
